import { h, render } from 'vue';
import MentionTooltip from 'vcomponents/richtext/customoptions/MentionTooltip.vue';
export function useBuildMention() {
    function buildMention(content, userLoggedId) {
        const idStaff = content.hasAttribute('data-mention-id')
            ? content.getAttribute('data-mention-id')
            : content.getAttribute('data-id');

        const vnode = h(MentionTooltip, {
            fullName: content.textContent.replace('@', ''),
            idStaff: +idStaff,
            userLoggedId,
            text: content.textContent,
        });

        if (window.sellsyapp?.appContext) {
            vnode.appContext = window.sellsyapp.appContext;
        }
        const container = document.createElement('div');
        render(vnode, container);

        return container.firstElementChild;
    }

    return { buildMention };
}
